import { useState } from 'react';
import { Controller, useFormContext } from 'react-hook-form';

import {
  Box,
  Avatar,
  Popper,
  TextField,
  Typography,
  Autocomplete,
  CircularProgress,
} from '@mui/material';
import { useLocale } from 'src/locales';

// ------------------------------------------------------

const CustomPopper = (props) => (
  <Popper
    {...props}
    placement="bottom-end"
    modifiers={[
      {
        name: 'offset',
        options: {
          offset: [20, 0],
        },
      },
    ]}
    style={{ width: 'auto' }} // 👈 set dropdown width here
  />
);
export function RHFAutocomplete({
  name,
  options = [],
  label = '',
  // getOptionLabel = (option) => option,
  // isOptionEqualToValue = (opt, val) => opt === val,
  loading = false,
  helperText,
  disabled = false,
  freeSolo = true,
  onInputChange: onExternalInputChange,
  onChange: onExternalChange,
  labelKey = 'label',
  imageKey = 'image',
  isImage = false,
  placeholder,
  extraWideOptions = false,
  noOptionsText,
  ...other
}) {
  const {
    control,
    formState: { disabled: isDisabled },
  } = useFormContext();

  const { t } = useLocale();

  const [inputValue, setInputValue] = useState('');

  function getByPath(obj, path) {
    return path.split('.').reduce((acc, key) => acc?.[key], obj);
  }

  const getLabel = (option) => t(option?.[labelKey] || '');
  const getImage = (option) => getByPath(option, imageKey) || '';

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <Autocomplete
          {...field}
          freeSolo={false}
          options={options}
          loading={loading}
          PopperComponent={extraWideOptions ? CustomPopper : undefined}
          fullWidth
          // isOptionEqualToValue={isOptionEqualToValue}
          // getOptionLabel={getOptionLabel}
          getOptionLabel={(option) => getLabel(option)}
          isOptionEqualToValue={(option, value) => getLabel(option) === getLabel(value)}
          noOptionsText={noOptionsText || t('No_options')}
          inputValue={inputValue}
          renderOption={(renderProps, option) => (
            <Box component="li" {...renderProps} display="flex" alignItems="center" key={option.id}>
              {isImage && (
                <Avatar
                  src={getImage(option)}
                  sx={{ width: 45, height: 45, mr: 1 }}
                  slotProps={{ img: { style: { objectFit: 'contain' } } }}
                />
              )}
              <Typography variant="body2">{getLabel(option)}</Typography>
            </Box>
          )}
          onInputChange={(e, value, reason) => {
            setInputValue(value);
            onExternalInputChange?.(e, value, reason);
          }}
          onChange={(event, newValue) => {
            field.onChange(newValue ?? '');
            onExternalChange?.(event, newValue);
            // if (name == 'trucktype') {
            //   setInputValue('');
            // }
          }}
          disabled={disabled || isDisabled}
          renderInput={(params) => (
            <TextField
              {...params}
              label={label}
              error={!!error}
              placeholder={placeholder}
              value={field.value ?? ''} // React-safe
              helperText={error?.message || helperText}
              slotProps={{
                formHelperText: {
                  sx: {
                    ml: 0,
                    mt: 0,
                  },
                },
              }}
              InputProps={{
                ...params.InputProps,
                endAdornment: (
                  <>
                    {loading ? <CircularProgress color="inherit" size={20} /> : null}
                    {params.InputProps.endAdornment}
                  </>
                ),
                startAdornment:
                  isImage && field.value ? (
                    <Avatar
                      src={getImage(field.value)}
                      sx={{ width: 33, height: 33 }}
                      slotProps={{ img: { style: { objectFit: 'contain' } } }}
                    />
                  ) : null,
              }}
              inputProps={{
                ...params.inputProps,
                readOnly: true, // ✅ actually prevents keyboard
              }}
              autoComplete="new-password"
            />
          )}
          {...other}
        />
      )}
    />
  );
}
